module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/banner/intro-video-vp8-500k-7a3f788f14543dba682628a63270dc0e.webm";